import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { getRates } from "../lib/api";
import { DEFAULT_RATES } from "../lib/costEngine";

const RatesContext = createContext(null);

export function RatesProvider({ children }) {
  const [rates, setRates] = useState(DEFAULT_RATES);

  const refresh = useCallback(async () => {
    try {
      const r = await getRates();
      if (r && typeof r === "object") setRates({ ...DEFAULT_RATES, ...r });
    } catch (e) {
      console.error("Failed to load rate card; using defaults.", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ rates, refresh }), [rates, refresh]);
  return <RatesContext.Provider value={value}>{children}</RatesContext.Provider>;
}

export function useRates() {
  const ctx = useContext(RatesContext);
  if (!ctx) throw new Error("useRates must be used within RatesProvider");
  return ctx;
}
